import CustomCell from 'src/components/Table/CustomCell';
import { pagesText } from 'src/constants/pagesText';
import { sortingMethods } from 'src/constants/table';
import { PORTAL_ROUTE } from 'src/constants/routes';

export const APP_CATALOG_ROUTE = `${PORTAL_ROUTE}/apps/app-catalog`;
export const APP_PORTFOLIO_ROUTE = `${PORTAL_ROUTE}/apps/app-portfolio`;

// Both lists are offered while the product moves from one to the other. A viewer who can reach only
// one of them gets no tab strip, which is how the section has always looked to a non-admin.
export const appsTabs = ({ canViewAppCatalog, canViewAppPortfolio }) => [
  ...(canViewAppCatalog ? [{ label: 'App Import Catalog', value: APP_CATALOG_ROUTE }] : []),
  ...(canViewAppPortfolio ? [{ label: 'App Portfolio', value: APP_PORTFOLIO_ROUTE }] : []),
];

export const headings = [
  {
    title: pagesText.dashboard.headings.configManagerName,
    name: 'environmentApplicationName',
    hasSorting: true,
    sortMethod: sortingMethods.initial,
    Component: CustomCell,
    field: 'FilterAppResult',
    sortingCellField: 'ConfigMgrAppName',
    sortFieldName: 'OrderQuery',
    width: '26%',
  },
  {
    title: pagesText.dashboard.headings.softwareCenterName,
    name: 'softwareCenterName',
    hasSorting: true,
    sortMethod: sortingMethods.initial,
    Component: CustomCell,
    field: 'FilterAppResult',
    sortingCellField: 'SoftwareCenterName',
    sortFieldName: 'OrderQuery',
    width: '16%',
  },
  {
    title: pagesText.dashboard.headings.publisher,
    name: 'publisher',
    hasSorting: true,
    sortMethod: sortingMethods.initial,
    Component: CustomCell,
    field: 'FilterAppResult',
    sortingCellField: 'ConfigMgrAppManufacturer',
    sortFieldName: 'OrderQuery',
    width: '12%',
  },
  {
    title: pagesText.dashboard.headings.versionsCount,
    name: 'versionsCount',
    hasSorting: false,
    sortMethod: sortingMethods.initial,
    width: '10%',
  },
  {
    title: pagesText.dashboard.headings.version,
    name: 'latestVersion',
    hasSorting: false,
    sortMethod: sortingMethods.initial,
    width: '10%',
  },
  {
    title: pagesText.dashboard.headings.installSize,
    name: 'installSize',
    hasSorting: false,
    sortMethod: sortingMethods.initial,
    width: '10%',
  },
  {
    title: pagesText.dashboard.headings.timestamp,
    name: 'createdAt',
    hasSorting: true,
    sortMethod: sortingMethods.initial,
    Component: CustomCell,
    field: 'DateFilter',
    filterFieldName: 'DateFilter',
    sortingCellField: 'CreatedAt',
    sortFieldName: 'OrderQuery',
    width: '10%',
  },
  {
    title: 'Source',
    name: 'source',
    hasSorting: false,
    sortMethod: sortingMethods.initial,
    width: '12%',
  },
  {
    title: '',
    width: '4%',
  },
];

export const columnsOrder = [
  {
    name: 'environmentApplicationName',
  },
  {
    name: 'softwareCenterName',
  },
  {
    name: 'publisher',
  },
  {
    name: 'versionsCount',
    isNumber: true,
  },
  {
    name: 'latestVersion',
  },
  {
    name: 'installSize',
    isNumber: true,
  },
  {
    name: 'createdAt',
  },
  {
    name: 'source',
    styles: { textTransform: 'capitalize' },
  },
];
